import React from 'react';
import { ContentCard } from '@/components/dataDisplay/cards/ContentCard';

import { Route, UserRouteProgress } from '@/services/routes/route.vm';
import { Content } from '@/services/contents/content.vm';
import { Stage } from '@/services/stages/stage.vm';
import Progress from '@/components/dataDisplay/Progress';

import StageComponent from './StageComponent';
import useUpdateLastVisit from './useUpdateLastVisit';
import useGetNextContent from './useGetNextContent';
import InitiatedRoutePlaceholder from './placeholder';
import { styles } from './styles';

interface Props {
  routeId?: Route['id'];
  userRouteProgressId?: UserRouteProgress['id'];
  progress?: Route['progress'];
  contents?: Content[];
  stages?: Stage[];
  stagesProgress?: Route['stagesProgress'];
  loading: boolean;
}

const InitiatedPath: React.FC<Props> = ({
  userRouteProgressId,
  progress,
  contents,
  stages,
  stagesProgress,
  routeId,
  loading,
}) => {
  useUpdateLastVisit({ userRouteProgressId });
  const { nextContent } = useGetNextContent({ userRouteProgressId });

  if (loading) return <InitiatedRoutePlaceholder />;
  if (!routeId) return null;

  return (
    <div style={styles.container}>
      <div style={styles.progressContainer}>
        <h2 style={styles.headerContainer}>
          <span style={styles.headerTitle}>Progreso</span>
          <span style={styles.headerTitle}>{Math.floor(progress ?? 0)}%</span>
        </h2>
        <Progress value={progress ?? 0} />
      </div>
      <ul style={styles.stagesContainer}>
        {stages?.map((item, index) => (
          <li key={item.id} style={{ display: 'contents' }}>
            <StageComponent
              stage={item}
              completedContents={stagesProgress?.[item.id] ?? 0}
              autoFocus={nextContent?.stageId === item.id}
              nextSuggestedContentId={nextContent?.id}
            />
          </li>
        ))}
      </ul>
      <div>
        {contents?.map((item, index) => (
          <ContentCard
            key={item.id}
            routeId={routeId}
            id={item.id}
            title={item.title}
            type={item.type}
            completed={item.completed}
            points={item.points}
            duration={item.duration}
            autoFocus={nextContent?.id === item.id}
          />
        ))}
      </div>
    </div>
  );
};

export default InitiatedPath;
